import { useParams } from 'react-router-dom'

import { Container } from '@/components'

import { ClienteDetailsCard } from '../components/cliente-details-card'
import { EquipamentoDetailsCard } from '../components/equipamento-details-card'
import { EvidenciasCard } from '../components/evidencias-card'
import { ItensCard } from '../components/itens-card'
import { OrdemDetailsCard } from '../components/ordem-details-card'
import { OrdemStepper } from '../components/ordem-stepper'
import { OrdemService } from '../services/ordem.service'

export function OrdemDetailsPublicPage() {
  const { hashId } = useParams()

  const { data, isLoading } = OrdemService.getPublicOrdemView(hashId)

  return (
    <div>
      {/* HEADER */}
      <header className="mb-8 border-b border-zinc-300">
        <Container className="flex h-12 items-center">
          <h1 className="text-2xl text-lime-600">Multitec</h1>
        </Container>
      </header>

      {/* BODY */}
      <main>
        <Container>
          {isLoading ? (
            <div>Carregando...</div>
          ) : data ? (
            <div className="mb-12 grid grid-cols-1 items-start gap-8 md:grid-cols-2">
              <div className="md:col-span-2">
                <OrdemStepper status={data.ordem.status} />
              </div>
              <ClienteDetailsCard cliente={data.cliente} />
              <EquipamentoDetailsCard equipamento={data.equipamento} />
              <OrdemDetailsCard ordem={data.ordem} />
              <EvidenciasCard evidencias={data.evidencias} />
              <div className="md:col-span-2">
                <ItensCard itens={data.itens} />
              </div>
            </div>
          ) : (
            <div className="space-y-4 text-center">
              <div className="text-lg font-bold">
                Desculpe. Não foi possível carregar os dados.
              </div>
              <div>
                Verifique se o endereço/ordem estão corretos. Se o erro
                persistir, contate um assistente da Multitec.
              </div>
            </div>
          )}
        </Container>
      </main>
    </div>
  )
}
